import wallet from "../services/wallet";
import notification from "../services/notification";
import { getField, updateField } from "vuex-map-fields";

const cappingFields = {
  limit: null,
  frequency: null,
  action: "create"
};
const emptyCappingDetails = {
  pay: [],
  topup: [],
  transfer: []
};
const formatCappingDetails = (details) => {
  for (const key in details) {
    if (details[key].length) {
      details[key] = details[key].map((item) => ({ ...item, action: "update" }));
    } else {
      details[key] = [{ ...cappingFields }];
    }
  }

  return details;
}

export default {
    namespaced: true,
    state: {
        loading: false,
        wallets: [],
        transactionHistory: [],
        walletDetails: { top_up: []},
        voucherOptions: [],
        rewardOptions: [],
        walletPagination: {
            maxPage: 1,
            nextPage: 0,
            prevPage: 0,
            currentPage: 1,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0
        },
        transactionHistoryPagination: {
            page: 1,
            perPage: 10,
            prevPage: null,
            nextPage: null,
            maxPage: null,
            startList: null,
            endList: null,
            message: null
        },
        search: {
            keyword: null,
            filter: null,
            dateFrom: null,
            dateTo: null
        },
        editing: false,
        errors: null,
        cappingFields,
        cappingDetails: emptyCappingDetails,
        cappingFieldsToDelete: emptyCappingDetails,
        customerWallets: [],
    },
    getters: {
      getField
    },
    mutations: {
        updateField,
        loading(state, value = true) {
            state.loading = value;
        },
        wallets(state, wallets) {
            state.wallets = wallets;
            state.loading = false;
            state.searching = false;
        },
        walletPagination(state, pagination) {
            state.walletPagination.totalPerPage = pagination.list.length;
            state.walletPagination.maxPage = pagination.max_page;
            state.walletPagination.prevPage = pagination.prev_page;
            state.walletPagination.nextPage = pagination.next_page;
            state.walletPagination.currentPage =
                state.walletPagination.prevPage + 1;
            state.walletPagination.currentFirstItem =
                state.walletPagination.initialPageCount *
                    state.walletPagination.prevPage +
                1;
            state.walletPagination.currentLastItem =
                state.walletPagination.currentFirstItem > 0
                    ? state.walletPagination.currentFirstItem +
                      state.walletPagination.totalPerPage -
                      1
                    : 0;
        },
        setWalletInitialPageCount(state, list) {
            state.walletPagination.initialPageCount = list.length;
        },
        transactionHistoryPagination(state, pagination) {
            state.transactionHistoryPagination.totalPerPage =
                pagination.list.length;
            state.transactionHistoryPagination.maxPage = pagination.max_page;
            state.transactionHistoryPagination.prevPage = pagination.prev_page;
            state.transactionHistoryPagination.nextPage = pagination.next_page;
            state.transactionHistoryPagination.currentPage =
                state.transactionHistoryPagination.prevPage + 1;
            state.transactionHistoryPagination.currentFirstItem =
                state.transactionHistoryPagination.initialPageCount *
                    state.transactionHistoryPagination.prevPage +
                1;
            state.transactionHistoryPagination.currentLastItem =
                state.transactionHistoryPagination.currentFirstItem > 0
                    ? state.transactionHistoryPagination.currentFirstItem +
                      state.transactionHistoryPagination.totalPerPage -
                      1
                    : 0;
        },
        setTransactionHistoryPage(state, page) {
            state.transactionHistoryPagination.page = page;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        editing(state, value) {
            state.editing = value;
        },
        setDetails(state, details) {
            state.walletDetails = details;
        },
        voucherOptions(state, voucherOptions) {
            state.voucherOptions = voucherOptions;
            state.loading = false;
            state.searching = false;
        },
        rewardOptions(state, rewardOptions) {
            state.rewardOptions = rewardOptions;
            state.loading = false;
            state.searching = false;
        },
        getTransactionHistoryFirstPage(state) {
            state.transactionHistoryPagination.page = 1;
        },
        getTransactionHistory(state, response) {
            state.transactionHistory = response.list;
            state.transactionHistoryPagination.maxPage = response.max_page;
            state.transactionHistoryPagination.nextPage = response.next_page;
            state.transactionHistoryPagination.prevPage = response.prev_page;
            state.transactionHistoryPagination.message = response.message;

            if (state.transactionHistoryPagination.page == 1) {
                state.transactionHistoryPagination.startList = 1;
            } else {
                state.transactionHistoryPagination.startList =
                    state.transactionHistoryPagination.perPage *
                        (state.transactionHistoryPagination.page - 1) +
                    1;
            }

            if (
                state.transactionHistoryPagination.page ==
                state.transactionHistoryPagination.maxPage
            ) {
                let count = state.transactionHistory.length;
                state.transactionHistoryPagination.endList =
                    state.transactionHistoryPagination.perPage *
                        (state.transactionHistoryPagination.page - 1) +
                    count;
            } else {
                state.transactionHistoryPagination.endList =
                    state.transactionHistoryPagination.perPage *
                    state.transactionHistoryPagination.page;
            }
        },
        setSearchFilter(state, filter) {
            state.search.keyword = filter.keyword;
            state.search.filter = filter.field == "all" ? null : filter.field;
            state.search.dateFrom = filter.dateFrom;
            state.search.dateTo = filter.dateTo;
        },
        setSearchDefault(state) {
            state.search.keyword = null;
            state.search.filter = null;
            state.search.dateFrom = null;
            state.search.dateTo = null;
        },
        setCustomerWallets(state, value) {
          state.customerWallets = value;
        },
        setCappingDetails(state, value) {
          state.cappingDetails = value;
        },
        setCappingFieldsToDelete(state, value) {
          state.cappingFieldsToDelete = value;
        }
    },
    actions: {
        async getWallets({ commit }, param) {
            commit("loading");
            try {
                let response = await wallet.getWallets(param);

                if (param.page == 1) {
                    await commit("setWalletInitialPageCount", response.list);
                }

                await commit("wallets", response.list);
                await commit("walletPagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        async resetEditing({ commit }) {
            commit("editing", false);
        },
        async editing({ commit }) {
            commit("editing", true);
        },
        async saveWallet({ commit }, param) {
            commit("loading");
            try {
                let response = await wallet.saveWallet(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot create new wallet.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewWallet({ commit, state}, uuid) {
            commit("loading");
            try {
                let response = await wallet.viewWallet(uuid);

                commit(
                  "setDetails", 
                  { ...state.walletDetails, ...response.details }
                );
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async updateWallet({ commit }, data) {
            commit("loading");
            try {
                let response = await wallet.updateWallet(data.uuid, data.param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                if (errors.errors.message) {
                    notification.warning(errors.errors.message);
                } else {
                    notification.warning("Oops, cannot update wallet.");
                }
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteWallet({ commit }, uuid) {
            commit("loading");
            try {
                await wallet.deleteWallet(uuid);
                notification.success("Wallet successfully deleted.");
                commit("loading", false);
            } catch (errors) {
                if (errors.errors.message) {
                    notification.warning(errors.errors.message);
                } else {
                    notification.warning("Oops, cannot delete wallet.");
                }
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getVoucherOptions({ commit }) {
            commit("loading");
            try {
                let voucherOptions = await wallet
                    .getVoucherOptions()
                    .then(voucher => {
                        return voucher.options.map(option => {
                            return {
                                text: option.name,
                                value: option.uuid
                            };
                        });
                    });
                await commit("voucherOptions", voucherOptions);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getRewardOptions({ commit }) {
            commit("loading");
            try {
                let rewardOptions = await wallet
                    .getRewardOptions()
                    .then(rewards => {
                        return rewards.map(reward => ({
                          text: reward.name,
                          value: reward.uuid
                      }));
                    });
                await commit("rewardOptions", rewardOptions);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        getTransactionHistoryFirstPage({ commit, dispatch }) {
            commit("getTransactionHistoryFirstPage");
            dispatch("getTransactionHistory");
        },
        async getTransactionHistory({ commit, state }) {
            commit("loading");
            try {
                let response = await wallet.getTransactionHistory(
                    state.transactionHistoryPagination.page,
                    state.search
                );

                commit("getTransactionHistory", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getCustomerWallets({ commit }, uuid) {
          commit("loading", true);
          commit("setCustomerWallets", []);

          try {
            const { data } = await wallet.getCustomerWallets(uuid)

            commit("setCustomerWallets", data);
          } catch (errors) {
            commit("errors", errors);
          } finally {
            commit("loading", false);
          }
        },
        async suspendCustomerWallet({ commit, state }, payload) {
          commit("loading", true);

          try {
            const { message } = await wallet.suspendCustomerWallet(payload)
            const is_suspended = payload.is_suspended;
            const customerWallets = state.customerWallets.map((item) =>
              item.customer_wallet_uuid === payload.customer_wallet_uuid
                ? { ...item, is_suspended }
                : item
            );
            
            commit("setCustomerWallets", customerWallets);
            notification.success(message);
          } catch (errors) {
            commit("errors", errors);
            notification.warning("Oops, cannot suspend or activate customer's wallet.");
          } finally {
            commit("loading", false);
          }
        },
        async getCappingDetails({ commit }) {
          commit("loading", true);

          try {
            const { data } = await wallet.getCappingDetails();

            commit("setCappingDetails", formatCappingDetails(data));
            commit("setCappingFieldsToDelete", emptyCappingDetails);
          } catch (errors) {
            commit("errors", errors);
          } finally {
            commit("loading", false);
          }
        },
        async saveCappingDetails({ commit }, payload) {
          commit("loading", true);

          try {
            const { data, message } = await wallet.saveCappingDetails(payload)
            
            commit("setCappingDetails", formatCappingDetails(data));
            commit("setCappingFieldsToDelete", emptyCappingDetails);
            notification.success(message);
          } catch (errors) {
            commit("errors", errors);
            notification.warning("Oops, cannot save wallet capping settings.");
          } finally {
            commit("loading", false);
          }
        },
    } 
};
